'use client';

import UpdateHashOnScroll from '@/lib/utils/UpdateHashOnScroll';
import { useTranslation } from 'react-i18next';
import ContactSection from './ContactSection';
import {
  MethodSection,
  OffersSection,
  TrustSection,
  UseCasesSection,
  WhyNowSection,
} from './ConsultingSections';
import Hero from './Hero';
import './HomePage.css';

export type HomePageContent = {
  heroTitle: string;
  heroSubtitle: string;
  heroCta: string;
  whyNowTitle: string;
  whyNowIntro: string;
  whyNowBlocks: { title: string; text: string }[];
  offersTitle: string;
  offersIntro: string;
  offers: { title: string; text: string }[];
  methodTitle: string;
  methodIntro: string;
  methodSteps: { number: string; title: string; text: string }[];
  useCasesTitle: string;
  useCasesIntro: string;
  useCasesList: string;
  trustTitle: string;
  trustText: string;
  contactTitle: string;
  contactCta: string;
};

export default function HomePage({ content }: { content: HomePageContent }) {
  const { t } = useTranslation();

  return (
    <div className="container mx-auto">
      <UpdateHashOnScroll sectionIds={['why-now', 'offers', 'method', 'use-cases', 'trust', 'contact']} />
      <Hero title={content.heroTitle} subtitle={content.heroSubtitle} cta={content.heroCta} />
      <section id="why-now">
        <WhyNowSection title={content.whyNowTitle} intro={content.whyNowIntro} blocks={content.whyNowBlocks} />
      </section>
      <section id="offers">
        <OffersSection title={content.offersTitle} intro={content.offersIntro} offers={content.offers} />
      </section>
      <section id="method">
        <MethodSection title={content.methodTitle} intro={content.methodIntro} steps={content.methodSteps} />
      </section>
      <section id="use-cases">
        <UseCasesSection title={content.useCasesTitle} intro={content.useCasesIntro} list={content.useCasesList} />
      </section>
      <section id="trust">
        <TrustSection title={content.trustTitle} text={content.trustText} />
      </section>
      <section id="contact">
        <ContactSection t={t} title={content.contactTitle} cta={content.contactCta} />
      </section>
    </div>
  );
}
